export default __webpack_public_path__ + "static/media/happy.4a2045a6.png";